// libs
import { Component, Inject, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";

// app
import { ERROR_KEYS } from 'src/app/_constants/app.constants';
import { RtcService } from "src/app/_services/sdk/rtc/rtc.service";
import { LoggerService } from 'src/app/_services/ui/logger/logger.service';
import { SessionService } from 'src/app/_services/session/session.service'; 
import { FeedbackService } from "src/app/_services/api/feedback/feedback.service";
import { LanguageService } from "src/app/_services/api/language/language.service";

@Component({
  selector: "ua-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
  providers:[FeedbackService]
})
export class LoadingComponent implements OnInit {

  // public
  state: any;
  isLocationAvailable = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private rtcService: RtcService,
    private logger: LoggerService
  ) {
  }

  /**
   *
   * Page initializiation
   *
   */
  async ngOnInit() {
    this.state = window.history.state;
    
    this.isLocationAvailable = this.sessionService.isLocationAvailable(
      this.route.snapshot.queryParamMap
    );
    this.redirectAsNeeded();
  }

  /**
   *
   * Redirect based on data
   *
   */
  redirectAsNeeded() {
    this.logger.debug(
      "Loading Page: redirectAsNeeded: ",
      this
    );
    if (this.state && this.state.redirect) {
      this.router.navigateByUrl(this.state.redirect);
    } else if (this.sessionService.isGenRoute()) {
      this.router.navigate(["/welcome"], { replaceUrl: true });
    } else if (this.sessionService.isDocCheck()) {
      this.router.navigate(["/welcome"], { replaceUrl: true });
    } else if (this.isLocationAvailable && this.route.snapshot.routeConfig.path != "") {
      this.router.navigate(["/pre-chat"], { replaceUrl: true });
    } else {
      this.router.navigate(["/welcome"], { replaceUrl: true });
    }

  }

  /**
   *
   * Redirect to no agents screen with approppriate params
   *
   */
  redirectToNoAgents() {
    this.logger.debug("Loading Page: redirectToNoAgents");
    this.router.navigate(["/no-agents"], {
      queryParams: {
        e: ERROR_KEYS.NON_WORKING_HOURS
      },
      replaceUrl: true,
    });
  }

}
